import { useState, useEffect } from "react";
import { Group, Circle, Rect, Text, Image, Label, Tag } from "react-konva";
import useImage from "use-image";

const Tuerchen = ({ handleOpenModal, ...props }) => {
  // state for each tuerchen
  const [isHovering1, setHovering1] = useState(false);
  const [tuerchenOpacity, setTuerchenOpacity] = useState(1.0);
  const [circleColorHover, setCircleColorHover] = useState("");
  const [circleOpacity, setCircleOpacity] = useState(0.0);
  const [circleOpacityHover, setCircleOpacityHover] = useState(0.32);
  const [tuerchenHoverColor, setTuerchenHoverColor] = useState("");
  const [tuerchenTime, setTuerchenTime] = useState("");
  const [circleOffsetX, setCircleOffsetX] = useState(0);
  const [circleOffsetY, setCircleOffsetY] = useState(18);
  const [circleRadius, setCircleRadius] = useState(42.5);
  const [tuerchenImage, setTuerchenImage] = useState("");
  const [tuerchenVideo, setTuerchenVideo] = useState("");

  // colors for tuerchen times (expired door, active door, upcoming door)
  const pastColor = props.calendarColors.colorHighlight;
  const presentColor = props.calendarColors.colorPrimary;
  const futureColor = props.calendarColors.colorTertiary;
  const defaultColor = props.calendarColors.fontColorText;
  const fontColorScrollpage = props.calendarColors.colorPrimary;

  // convert current date and date of tuerchen to the same format and set the time to 0 to only compare by day
  let currentDate = new Date();
  currentDate.setHours(0, 0, 0, 0);

  let tuerchenDate = new Date(props.date);
  tuerchenDate.setHours(0, 0, 0, 0);
  // 40 46 50


  let tempDate = new Date("2022-12-24");
  tempDate.setHours(0, 0, 0, 0);
  console.log(tempDate.valueOf());

  tempDate = new Date("2022-12-26");
  tempDate.setHours(0, 0, 0, 0);
  console.log(tempDate.valueOf());




  /* Checks for the current day and set the visual offset of the circle behind the tuerchen and also determine the color of
  the tuerchen depending if its date is expired, present or in the future. Also sends the information to the callback in App.js
  to show its modal with the related data. */
  const checkCalendarDate = () => {
    //console.log(props.day);
    // set the circle offset depending on the number of digits of the day to center circle around the digit
    if (props.day < 10) {
      if (props.scaleText > 40) {
        setCircleOffsetX(17);
        setCircleOffsetY(21);
      } else {
        setCircleOffsetX(13);
      }
    } else {
      if (props.scaleText > 40) {
        setCircleOffsetX(24);
        setCircleOffsetY(21);
      } else {
        setCircleOffsetX(25);
      }
    }
    // compare the current date with the tuerchen date to set colors accordingly
    /* console.log(
      "Heute: " +
        currentDate.toString() +
        " und Türchen: " +
        tuerchenDate.toString()
    ); */
    // comparing dates: used valueOf() instead toString() - toString seems to be inconsistent
    /* console.log(currentDate.valueOf() === tuerchenDate.valueOf());
    console.log(currentDate.valueOf() < tuerchenDate.valueOf());
    console.log(currentDate.valueOf() > tuerchenDate.valueOf()); */
    if (currentDate.valueOf() === tuerchenDate.valueOf()) {
      // present
      setTuerchenOpacity(0.32);
      setCircleOpacity(0.0);
      setCircleOpacityHover(0.32);
      setCircleColorHover(presentColor);
      setTuerchenHoverColor(presentColor);
      setTuerchenTime("present");
      // set present value for callback
    } else if (currentDate.valueOf() < tuerchenDate.valueOf()) {
      // future
      setTuerchenOpacity(0.16);
      setCircleOpacity(0.0);
      setCircleOpacityHover(0.32);
      setCircleColorHover(futureColor);
      setTuerchenHoverColor(futureColor);
      setTuerchenTime("future");
    } else {
      // tuerchen of 24 Dec is supposed to be opened for 3 days:
      // check if date of tuerchen is 2021-12-24 and let it be "present" until 2021-12-27
      // 1640300400000 24 Dec //  26 Dec 1640473200000 // 27 Dec 1640559600000 // 28 Dec 1640646000000 (for testing: 16 Dec 1639609200000)
      if (
        tuerchenDate.valueOf() === 1640300400000 &&
        currentDate.valueOf() < 1640559600000
      ) {
        // make 24th present
        setTuerchenOpacity(0.32);
        setCircleOpacity(0.0);
        setCircleOpacityHover(0.32);
        setCircleColorHover(presentColor);
        setTuerchenHoverColor(presentColor);
        setTuerchenTime("present");
        /* console.log(
          Date.parse(
            "Mon Dec 28 2021 00:00:00 GMT+0100 (Mitteleuropäische Normalzeit)"
          )
        ); */
      } else {
        // past
        setTuerchenOpacity(0.5);
        setCircleOpacity(0.16);
        setCircleOpacityHover(0.64);
        setCircleColorHover(pastColor);
        setTuerchenHoverColor(defaultColor);
        setTuerchenTime("past");
      }
    }

    // adjust circle radius depending on text size
    if (props.scaleText === 48) {
      setCircleRadius(46.5);
    } else if (props.scaleText === 56) {
      setCircleRadius(50.5);
    }
  };

  /* React hook to call checkDigitCount-Method on first render only. Also set the media data. */
  useEffect(() => {
    checkCalendarDate();
    // check if video data exists first, then check if image exists (for videos both media fields can exist, images only the image)
    // typeof props.media.image !== "undefined" && props.media.image
    if (typeof props.media.video !== "undefined" && props.media.video) {
      // mediaVideo = props.media.video;
      const videoID = props.media.video.replace(
        "https://www.youtube.com/embed/",
        ""
      );
      setTuerchenVideo(props.media.video);
      if (typeof props.media.image !== "undefined" && props.media.image) {
        setTuerchenImage(props.media.image);
      } else {
        const ytImageURL = "http://img.youtube.com/vi/" + videoID + "/0.jpg";
        setTuerchenImage(ytImageURL);
      }
    } else if (typeof props.media.image !== "undefined" && props.media.image) {
      setTuerchenImage(props.media.image);
    }
    // eslint-disable-next-line
  }, []);

  // callback to open modal with the clicked tuerchen and its informations/image/giveaway
  const modalCallback = () => {
    //console.log(tuerchenTime);
    // give tuerchen data to the modal
    handleOpenModal(
      props.day,
      props.intro,
      props.modalHeading,
      props.formHeading,
      props.description,
      props.giveawayTitle,
      props.shortDescription,
      props.quizQuestion,
      props.quizAnswers,
      props.correct,
      tuerchenImage,
      tuerchenVideo,
      tuerchenTime,
      props.showGiveaway
    );
  };

  // Element for expired doors that is showing the giveaway prize image
  const ExpiredGiveawayImage = () => {
    const [image] = useImage(tuerchenImage);
    return (
      <Image
        image={image}
        x={props.positionX - 84}
        y={props.positionY + 21}
        width={200}
        height={133.25}
        opacity={isHovering1 ? 0.64 : 0.32}
      />
    );
  };
  // default: false; shows just the expired calendar day, without the image
  // todo: expand JSON with useDayWithoutImage field
  const useDayWithoutImage = false;

  /* Check if useImageInsteadOfDay is true. If so the tuerchen are displayed with images and an overlay according to its date. */
  if (props.useImageInsteadOfDay === true) {
    return (
      <>
        <Group
          onMouseEnter={(e) => {
            // style cursor pointer:
            const container = e.target.getStage().container();
            container.style.cursor = "pointer";
            // set hovering to true for style changes
            setHovering1(true);
          }}
          onMouseLeave={(e) => {
            const container = e.target.getStage().container();
            container.style.cursor = "default";
            setHovering1(false);
          }}
          onClick={() => modalCallback()}
          onTap={() => modalCallback()}
        >
          {useDayWithoutImage ? null : <ExpiredGiveawayImage />}
          <Rect
            x={props.positionX - 84}
            y={props.positionY + 21}
            width={200}
            height={133.25}
            fill={isHovering1 ? circleColorHover : pastColor}
            opacity={isHovering1 ? circleOpacityHover : circleOpacity}
          ></Rect>
        </Group>
      </>
    );
  }

  /* checks if day is of type number or string and then check if
  the tuerchen is present (future = same layot as present just different colors) or past */
  if (typeof props.day === "string") {
    /* Only show image when the tuerchen has expired.
    (Excludes the 24th of Dec for 3 days/ til after 27th Dec) */
    // and if tuerchenDate !== 24th and currentDate > 26th Dec
    /*

    */
    if (
      currentDate.valueOf() > tuerchenDate.valueOf()&&
      (tuerchenDate.valueOf() !== 1640300400000 ||
        currentDate.valueOf() > 1640473200000)
    ) {
      return (
        <>
          <Group
            onMouseEnter={(e) => {
              // style cursor pointer:
              const container = e.target.getStage().container();
              container.style.cursor = "pointer";
              // set hovering to true for style changes
              setHovering1(true);
            }}
            onMouseLeave={(e) => {
              const container = e.target.getStage().container();
              container.style.cursor = "default";
              setHovering1(false);
            }}
            onClick={() => modalCallback()}
            onTap={() => modalCallback()}
          >
            {useDayWithoutImage ? null : <ExpiredGiveawayImage />}
            <Label
              x={props.positionX - 84}
              y={props.positionY - 43}
              transformsEnabled="position"
            >
              <Tag
                fill={isHovering1 ? circleColorHover : pastColor}
                opacity={isHovering1 ? circleOpacityHover : circleOpacity}
                transformsEnabled="position"
              />
              <Text
                text={props.day}
                padding={12}
                fontFamily={props.loaded ? props.fontFamily : "Roboto"}
                fontSize={isHovering1 ? props.scaleText + 2 : props.scaleText}
                fill={isHovering1 ? tuerchenHoverColor : circleColorHover}
                opacity={ 1.0}
                wrap="none"
                transformsEnabled="position"
              />
            </Label>
          </Group>
        </>
      );
    } else {
      return (
        <>
          <Label
            x={props.positionX}
            y={props.positionY}
            transformsEnabled="position"
            onMouseEnter={(e) => {
              // style cursor pointer:
              const container = e.target.getStage().container();
              container.style.cursor = "pointer";
              // set hovering to true for style changes
              setHovering1(true);
            }}
            onMouseLeave={(e) => {
              const container = e.target.getStage().container();
              container.style.cursor = "default";
              setHovering1(false);
            }}
            onClick={() => modalCallback()}
            onTap={() => modalCallback()}
          >
            <Tag
              stroke={circleColorHover}
              strokeWidth={4}
              fill={isHovering1 ? circleColorHover : pastColor + "00"}
              opacity={circleOpacityHover}
              transformsEnabled="position"
            />
            <Text
              text={props.day}
              padding={12}
              fontFamily={props.loaded ? props.fontFamily : "Roboto"}
              fontSize={isHovering1 ? props.scaleText + 2 : props.scaleText}
              fill={isHovering1 ? tuerchenHoverColor : circleColorHover}
              opacity={1.0}
              wrap="none"
              transformsEnabled="position"
            />
          </Label>
        </>
      );
    }
  } else if (typeof props.day === "number") {
    /* Only show giveaway prize image when the tuerchen has expired.
    (Excludes the 24th of Dec for 3 days/ til after 27th Dec) */
    // and if tuerchenDate !== 24th and currentDate > 26th Dec
    if (
      currentDate.valueOf() > tuerchenDate.valueOf() &&
      (tuerchenDate.valueOf() !== 1640300400000 ||
        currentDate.valueOf() > 1640473200000)
    ) {
      return (
        <>
          <Group
            onMouseEnter={(e) => {
              // style cursor pointer:
              const container = e.target.getStage().container();
              container.style.cursor = "pointer";
              // set hovering to true for style changes
              setHovering1(true);
            }}
            onMouseLeave={(e) => {
              const container = e.target.getStage().container();
              container.style.cursor = "default";
              setHovering1(false);
            }}
            onClick={() => modalCallback()}
            onTap={() => modalCallback()}
          >
            {useDayWithoutImage ? null : <ExpiredGiveawayImage />}
            <Circle
              x={props.positionX + circleOffsetX}
              y={props.positionY + circleOffsetY}
              radius={circleRadius}
              stroke={circleColorHover}
              strokeWidth={4}
              fill={isHovering1 ? circleColorHover : pastColor}
              opacity={1.0}
            ></Circle>
            <Text
              x={props.positionX}
              y={props.positionY}
              text={props.day}
              fontSize={isHovering1 ? props.scaleText + 2 : props.scaleText}
              fontFamily={props.loaded ? props.fontFamily : "Roboto"}
              fill={isHovering1 ? tuerchenHoverColor : circleColorHover}
              opacity={1.0}
            />
          </Group>
        </>
      );
    } else {
      return (
        <>
          <Group
            onMouseEnter={(e) => {
              // style cursor pointer:
              const container = e.target.getStage().container();
              container.style.cursor = "pointer";
              // set hovering to true for style changes
              setHovering1(true);
            }}
            onMouseLeave={(e) => {
              const container = e.target.getStage().container();
              container.style.cursor = "default";
              setHovering1(false);
            }}
            onClick={() => modalCallback()}
            onTap={() => modalCallback()}
          >
            <Circle
              x={props.positionX + circleOffsetX}
              y={props.positionY + circleOffsetY}
              radius={circleRadius}
              stroke={circleColorHover}
              strokeWidth={4}
              fill={isHovering1 ? circleColorHover : pastColor + "00"}
              opacity={circleOpacityHover}
            ></Circle>
            <Text
              x={props.positionX + 7}
              y={props.positionY}
              text={props.day}
              fontSize={isHovering1 ? props.scaleText + 2 : props.scaleText}
              fontFamily={props.loaded ? props.fontFamily : "Roboto"}
              fill={isHovering1 ? tuerchenHoverColor : defaultColor}
              opacity={ 1.0 }
            />
          </Group>
        </>
      );
    }
  }

  return null;
};

export default Tuerchen;
